var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.svg#settings-adjust--IOkqK';
                    var viewUrl = 'sprites.svg#view-settings-adjust--IOkqK';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };